module.exports = __webpack_public_path__ + "img/9_65.f7a95222.png";